import { MENU } from "@/lib/brand";

function Section({ data, accent }) {
  return (
    <div
      data-testid={`menu-section-${data.eyebrow.toLowerCase().includes("specialty") ? "specialty" : "everyday"}`}
      className={[
        "rounded-3xl p-7 sm:p-10 md:p-14 border",
        accent
          ? "bg-[#1A1A1A] text-[#F7F5F0] border-[#1A1A1A]"
          : "bg-background border-border",
      ].join(" ")}
    >
      <div className="flex flex-col gap-5 pb-7 border-b border-current/15 md:flex-row md:items-end md:justify-between md:gap-8">
        <div className="min-w-0">
          <p className="overline mb-3 text-[#C47253]">{data.eyebrow}</p>
          <h3 className="font-serif text-3xl md:text-4xl leading-tight break-words">{data.title}</h3>
          <p className={"mt-3 text-sm max-w-xl leading-relaxed " + (accent ? "text-[#DDE3D5]" : "text-[#5C7365]")}>
            <span className="block italic font-serif text-base text-current">{data.grade}</span>
            {data.notes}
          </p>
        </div>
        <span
          className={[
            "text-[10px] uppercase tracking-[0.2em] rounded-full px-3 py-2 self-start max-w-full md:max-w-[220px] text-center md:text-left",
            accent ? "bg-[#F7F5F0] text-[#1A1A1A]" : "bg-[#EBEFDE] text-[#2C4C3B]",
          ].join(" ")}
        >
          {data.pricing_note}
        </span>
      </div>

      <ul className="mt-2 divide-y divide-current/10">
        {data.items.map((it) => (
          <li
            key={it.name}
            data-testid={`menu-item-${it.name.replace(/\s+/g, "-").toLowerCase()}`}
            className="py-6 md:py-7 flex items-baseline gap-6 group"
          >
            <div className="flex-1 min-w-0">
              <h4 className="font-serif text-xl md:text-2xl leading-tight">{it.name}</h4>
              <p className={"text-sm mt-1.5 leading-relaxed max-w-2xl " + (accent ? "text-[#DDE3D5]" : "text-[#5C7365]")}>
                {it.desc}
              </p>
            </div>
            <span
              className={[
                "font-serif text-xl md:text-2xl whitespace-nowrap tabular-nums",
                "before:content-['·····'] before:mr-4 before:tracking-[0.4em] before:opacity-30 before:hidden md:before:inline",
              ].join(" ")}
            >
              ₹{it.price}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function MenuPreview() {
  return (
    <section id="menu" className="px-6 md:px-10 py-24 md:py-32" data-testid="menu-section">
      <div className="max-w-6xl mx-auto">
        <div id="grades" className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <p className="overline text-[#C47253] mb-4">Two grades · Two roles</p>
            <h2 className="font-serif font-light text-4xl md:text-5xl text-[#1A2B22] leading-[1.05]">
              Named in your cup — <em className="text-[#2C4C3B]">never substituted</em>.
            </h2>
          </div>
          <p className="text-sm text-[#5C7365] max-w-sm leading-relaxed">
            Each grade is sourced for a different job. We don&apos;t blend them to pad a margin and we don&apos;t
            rebrand one as the other depending on the order.
          </p>
        </div>

        <div className="space-y-5">
          <Section data={MENU.specialty} accent />
          <Section data={MENU.everyday} />
        </div>
      </div>
    </section>
  );
}
